<ng-container *transloco="let t">
  @if (isAdmin) {
    <div class="admin-wrapper">
      <ng-template [ngTemplateOutlet]="messagesAdmin"></ng-template>
    </div>
  } @else {
    <app-page-template>
      <div class="pb-300-100">
        <ng-template [ngTemplateOutlet]="messagesCompetitor"></ng-template>
      </div>
    </app-page-template>
  }

  <ng-template #messagesAdmin>
    <app-nav-tabs [reduceHorizontalSpacing]=true (onChange)="navigate($event)" #adminNav [active]="activeNav">
      <app-nav-tab [title]="t('app.common.unread')" [itemId]="MessageTab.UNREAD">
        <ng-template>
          <ng-template [ngTemplateOutlet]="adminMessageTable"></ng-template>
        </ng-template>
      </app-nav-tab>
      <app-nav-tab [title]="t('app.common.read')" [itemId]="MessageTab.READ">
        <ng-template>
          <ng-template [ngTemplateOutlet]="adminMessageTable"></ng-template>
        </ng-template>
      </app-nav-tab>
    </app-nav-tabs>
  </ng-template>

  <ng-template #messagesCompetitor>
    <div class="nav-bar-padding">
      <div class="container">
        <app-nav-tabs (onChange)="navigate($event)" #competitorNav [active]="activeNav">
          <app-nav-tab [title]="t('app.common.unread')" [itemId]="MessageTab.UNREAD">
            <ng-template>
              <ng-template [ngTemplateOutlet]="competitorMessageTable"></ng-template>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.common.read')" [itemId]="MessageTab.READ">
            <ng-template>
              <ng-template [ngTemplateOutlet]="competitorMessageTable"></ng-template>
            </ng-template>
          </app-nav-tab>
        </app-nav-tabs>
      </div>
    </div>
  </ng-template>

  <ng-template #adminMessageTable>
    <div class="admin-card mb-3">
      @if (isLoading) {
        <app-loader [isLoading]="true" @fadeInAnimation></app-loader>
      } @else {
        @if (messages && messages.length > 0) {
          @if (activeNav === MessageTab.READ) {
            <div class="d-flex justify-content-end pb-4">
              <app-rounded-button [label]="t('app.common.delete.all')" (onClick)="onDeleteAll()"/>
            </div>
          }
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table [cssClass]="'table table-last-row-no-border'">
              <thead>
              <tr>
                <th scope="col">{{t('messages.title')}}
                </th>
                <th scope="col">{{t('messages.content')}}
                </th>
                <th scope="col" class="icon-cell-width"></th>
              </tr>
              </thead>
              <tbody>
                @for (message of messages;track message.id) {
                  <tr>
                    <td class="text-left">
                      {{message.title ?? t('messages.title.empty')}}
                    </td>
                    <td class="text-left">
                      {{message.body ?? t('messages.content.empty')}}
                    </td>
                    <td class="icon-cell-width center-align text-right">
                      @if (message.read) {
                        <span class="color-primary cursor-pointer" (click)="onDeleteMessage(message.id)"><i
                          class="bi bi-trash"></i></span>
                      } @else {
                        <span class="color-primary cursor-pointer" (click)="onMarkAsRead(message.id)"><i
                          class="bi bi-check-square"></i></span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div><!--      Mobile table-->
          @for (message of messages;track message.id;let isLast=$last;) {
            <div class="d-block d-xl-none">
              <div class="d-flex justify-content-end align-items-center mobile-table-row" [class.isLastRow]="isLast">
                <div class="flex-grow-1">
                  <div class="d-flex flex-column" [class.isLastRow]="isLast">
                    <div>
                      <strong>{{t('messages.title')}}:</strong> {{message.title}}
                    </div>
                    <div>
                      <strong>{{t('messages.message')}}:</strong> {{message.body}}
                    </div>
                  </div>
                </div>
                <div>
                  @if (message.read) {
                    <span class="menu-icon color-primary" (click)="onDeleteMessage(message.id)"><i
                      class="bi bi-trash"></i></span>
                  } @else {
                    <span class="menu-icon color-primary" (click)="onMarkAsRead(message.id)"><i class="bi bi-trash"></i></span>
                  }
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="pt-2 pb-4">
            <app-empty-state-admin/>
          </div>
        }
      }

    </div>
  </ng-template>
  <ng-template #competitorMessageTable>
    <div class="pt-62-32 pb-300-100">
      @if (isLoading) {
        <app-loader [isLoading]="true" @fadeInAnimation></app-loader>
      } @else {
        @if (messages && messages.length > 0) {
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table cssClass="table table-striped align-middle header">
              <thead class="sticky-table-header">
              <tr>
                <th scope="col">{{t('messages.title')}}</th>
                <th scope="col">{{t('messages.message')}}</th>
                <th scope="col" class="icon-cell-width"></th>
              </tr>
              </thead>
              <tbody>
                @for (message of messages;track message.id) {
                  <tr class="fs-13-px fw-semibold">
                    <td class="text-left">
                      {{message.title ?? t('messages.title.empty')}}
                    </td>
                    <td class="text-left">
                      {{message.body ?? t('messages.content.empty')}}
                    </td>
                    <td class="icon-cell-width text-center center-align">
                      @if (message.read) {
                        <span class="color-primary cursor-pointer" (click)="onDeleteMessage(message.id)"><i
                          class="bi bi-trash"></i></span>
                      } @else {
                        <span class="color-primary cursor-pointer" (click)="onMarkAsRead(message.id)"><i
                          class="bi bi-check-square"></i></span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div><!--      Mobile table-->
          @for (message of messages;track message.id;let isLast=$last;) {
            <div class="align-items-center d-flex d-xl-none">
              <div class="d-flex flex-row align-items-center py-3 item-border-bottom flex-grow-1">
                <div class="d-flex flex-column flex-grow-1 pe-4">
                      <span class="fw-bold line-height-12 pb-2">
                         {{message.title}}
                      </span>
                  <span class="fs-13-px fw-semibold line-height-12">
                      {{message.body}}
                      </span>
                </div>
                @if (message.read) {
                  <span class="color-primary cursor-pointer" (click)="onDeleteMessage(message.id)"><i
                    class="bi bi-trash"></i></span>
                } @else {
                  <span class="color-primary cursor-pointer" (click)="onMarkAsRead(message.id)"><i
                    class="bi bi-trash"></i></span>
                }
              </div>
            </div>
          }
          @if (activeNav === MessageTab.READ) {
            <div class="d-flex justify-content-end mt-4">
              <app-rounded-button [label]="t('app.common.delete.all')" [isDisabled]="messages.length === 0"
                                  (onClick)="onDeleteAll()"/>
            </div>
          }
        } @else {
          <div class="pt-2 pb-4">
            <app-empty-state/>
          </div>
        }
      }
    </div>
  </ng-template>
</ng-container>
